import { EDITORIAL } from "@/data/product";
import { Reveal, Overline } from "@/components/common/ui";
import { mediaUrl as M } from "@/data/pdpMedia";

export const EditorialFeatures = () => (
  <section className="bg-[#FFF0E8] py-20 md:py-28" data-testid="editorial-features">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="flex snap-x snap-mandatory gap-6 overflow-x-auto pb-2 [-ms-overflow-style:none] [scrollbar-width:none] md:block md:space-y-28 md:overflow-visible md:pb-0 [&::-webkit-scrollbar]:hidden">
      {EDITORIAL.map((e, i) => (
        <div key={i} className={`w-[86%] shrink-0 snap-start grid items-center gap-6 sm:w-[70%] md:w-full md:gap-16 lg:grid-cols-2 ${e.reverse ? "" : ""}`}>
          <Reveal className={`hover-zoom overflow-hidden rounded-[2rem] border border-[#F2E8E6] shadow-[0_40px_80px_-40px_rgba(62,50,43,0.4)] ${e.reverse ? "lg:order-2" : ""}`}>
            <img src={M(`pdp_editorial_${i + 1}`)} data-media-slot={`pdp_editorial_${i + 1}`} data-media-type="image" alt={e.title} className="aspect-[4/3] w-full object-cover" />
          </Reveal>
          <Reveal delay={0.1} className={e.reverse ? "lg:order-1" : ""}>
            <Overline>{e.overline}</Overline>
            <h2 className="mt-4 font-display text-4xl font-light leading-[1.05] text-[#2C2B2C] sm:text-5xl">{e.title}</h2>
            <p className="mt-6 max-w-md text-base font-light leading-relaxed text-[#8A7F86] md:text-lg">{e.body}</p>
          </Reveal>
        </div>
      ))}
      </div>
    </div>
  </section>
);
